import { Message as MessageEntity } from '@twilio/conversations/lib/message';

// mirror twilio types
export { Conversation } from '@twilio/conversations/lib/conversation';
export { Client as ConversationsClient } from '@twilio/conversations';
export { Paginator } from '@twilio/conversations/lib/interfaces/paginator';
export { Message as MessageEntity } from '@twilio/conversations/lib/message';

export interface Message {
  body: string;
  date: Date;
  inbound: boolean;
  media?: MessageMedia;
  messageEntity: MessageEntity;
}

export interface MessageMedia {
  fileName: string;
}
